var colors = ['#2f7ed8', '#0d233a', '#8bbc21', '#910000', '#1aadce', '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'];
var markers_array=[],color_array_to_print=[],map;

String.prototype.capitalizeFirstLetter = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
}
// var prevWord = null;
var responseData = null;
var currentRequest = [];

export function asyncFilter(input, value, callback, siteId = null, toolId = null, userFilter) {

    // status = null;
    // if (prevWord == null) {
    //     prevWord = input;
    //     status = true;
    // } else {
    //     if (prevWord != input) {
    //         prevWord = input;
    //         status = true;
    //     }
    // }
    // if (status == null)
    //     status = false;
    var url = null;
    switch (value) {
        case 'propertyLabel':
            url = '/user/getwordproplabel';
            responseData = null;
            break;
        case 'propLabel':
        case 'locationColumns':
            url = '/user/getwordprop';
            // responseData=!input && filter_values_labels?JSON.parse(filter_values_labels):null;
            responseData = null;
            break;
        case 'alfred':
            url = '/user/getwordalfred';
            responseData = null;
            break;
        case 'metric':
            url = '/user/getwordmetric';
            responseData = null;
            break;
        case 'exclude':
            url = '/user/getwordexclude';
            responseData = null;
            break;
        default:
            url = '/user/getword';
            // responseData=!input && filter_values?JSON.parse(filter_values):null;
            responseData = null;
    }
    if (!responseData) {

        var userId = localStorage.Cookies ? JSON.parse(localStorage.Cookies).userId : null;
        var sessionId = localStorage.Cookies ? encodePassword(JSON.parse(localStorage.Cookies).sessionId) : null;
        //var siteId = localStorage.Cookies ? JSON.parse(localStorage.Cookies).siteId : null;
        var authorization_value = null;
        authorization_value = "Basic " + btoa(encodePassword(userId) + ":");

        currentRequest[value] = jQuery.ajax({
            type: 'Get',
            data: { word: input, value: userFilter ? null : value, filter_siteId: siteId, filter_toolId: toolId, urltype: "/user/getword" },
            headers: { Authorization: authorization_value, sessionId: sessionId },
            url: "/user/search",
            beforeSend: function () {
                if (currentRequest[value] != null) {
                    currentRequest[value].abort();
                }
            },
            success: function (response) {
                response = decodeResponseBody(response)
                checkIfSessionTimedOut(response)
                checkIfMaintenanceModeOn(response)
                // response=[{label:"Demo",value:"Demo1"}];
                if (!userFilter && value && value != 'alfred' && value != 'mega_filter' && value != "metric" && value != "locationColumns") {
                    if (value.toLowerCase() == 'locationcolumns')
                        response.unshift({ label: 'All', value: 'all' });
                    else response.unshift({ label: 'Total', value: '', type: "propertyLabel" });
                    if (input === '') {
                        property_filter = response.filter(function (demo, index) {
                            if (demo.value === propertyMain)
                                property_current_index = index
                            return demo.type === "propertyLabel"
                        }.bind(property_current_index));
                    }
                }
                responseData = response;
                if (responseData) {
                    var data = {
                        options: response.slice(0, 50),
                        complete: response.length <= 50,
                    };
                    if (value == 'alfred' || value == 'metric') {
                        callback(data.options, data.options);
                    } else {
                        callback(null, data);
                    }
                }
            }
        })
    } else {
        var data = {
            options: responseData.slice(0, 50),
            complete: responseData.length <= 50,
        };
        if (value == 'alfred' || value == 'metric') {
            callback(data.options, data.options);
        } else {
            callback(null, data);
        }
    }
}

export function getCorrectedMetric(metric) {
    var finalMet = [];
    metric = metric.split(",");
    for (var index in metric) {
        var value = metric[index];
        var met = value.match(/([A-Z]?[^A-Z]*)/g).slice(0, -1);
        var temp = '';
        for (var i in met) {
            var val = met[i];
            var t = val.capitalizeFirstLetter();
            if (t == 'Avg')
                t = 'Average';
            temp += t + " ";
        }
        finalMet.push(temp);
    }
    return finalMet.toString();
}

export function refineTotalData(data, metric, period) {
    data=data[0];
    sampleData = {};
    sampleData.label = 'Total';
    var roundOff = 0;
    var $roundOff = 0;
    metric.map(function(innerData) {
        valObj = innerData.value;
        if(period)
            value = data[innerData.label];
        else value = data[valObj];
        if (value)
            value = value.toString();
        roundOff = innerData.roundOff;
        $roundOff = parseInt(roundOff);
        if (typeof value == 'string') {
            if(value=="*")
                value=0;
            // value = value == undefined || value == '' ? 0 : delimitNumbersIndianFormat(parseFloat(value));
            value = value == undefined || value == '' ? 0 : number_shorten(value.toString(), innerData.roundOff, innerData.numberShorten);
            // if (typeof value == 'string') {
            //     var dot = value.indexOf('.');
            //     if ($roundOff == 0)
            //         value = value.substring(0, dot);
            //     else
            //         value = value.substring(0, (dot + $roundOff + 1));
            // }
        }
        // var label=innerData.label;
        var label=valObj;
        // if(innerData.defaultFormula)
        //     label=innerData.label.charAt(0).toLowerCase() + innerData.label.slice(1);
        sampleData[label] = value;
    });
    return sampleData;
}

// Shortens a number and attaches K, M, B, etc. accordingly
export function number_shorten(oldnumber, precision, metricUnit) {
    oldnumber = parseFloat(oldnumber);
    oldnumber = isNaN(oldnumber) ? "0" : oldnumber;
    if(oldnumber) {
        
        oldnumber = oldnumber == 'N.A.' ? 0 : oldnumber;
        if (typeof oldnumber == "number")
            oldnumber = oldnumber.toString();
        var tempDecimal = oldnumber.split('.')[1];
        let number = oldnumber.split('.')[0];
        var divisors = null;
        var limitNumbersTo = 2; //is used limit minimum numbers
        // Setup default $divisors if not provided
        if (!divisors) {
            if (!metricUnit)
                metricUnit = "in";
            if (metricUnit.trim() == "in") {
                divisors = [
                    { key: 1, value: '' },
                    { key: 10, value: '' },
                    { key: 100, value: '' },
                    { key: Math.pow(1000, 1), value: 'K' }, // Thousand 
                    { key: 100000, value: 'L' }, // Million 
                    { key: 10000000, value: 'Cr' }, // Billion            
                    // { key: 10000000000, value: 'K Cr' }, // Billion            
                    // { key: 1000000000000, value: 'L Cr' }, // Billion            
                    // { key: 100000000000000, value: 'Cr Cr' }, // Billion                        
                ];
                limitNumbersTo = 2;
            } else if (metricUnit.trim() == "k") {
                divisors = [
                    { key: Math.pow(1000, 1), value: 'K' }, // Thousand 
                ];
                limitNumbersTo = 2;
            } else if (metricUnit.trim() == "l") {
                divisors = [
                    { key: 100000, value: 'L' }, // Million 
                ];
                limitNumbersTo = 2;
            } else if (metricUnit.trim() == "cr") {
                divisors = [
                    { key: 10000000, value: 'Cr' }, // Billion            
                ];
                limitNumbersTo = 2;
            } else if (metricUnit.trim() == "ml" || metricUnit.trim() == "m") {
                divisors = [
                    { key: 1000000, value: 'M' }, // Million            
                ];
                limitNumbersTo = 2;
            } else {
                divisors = [
                    { key: 1, value: '' },
                    { key: 10, value: '' },
                    { key: 100, value: '' },
                    { key: Math.pow(1000, 1), value: 'K' }, // Thousand 
                    { key: 1000000, value: 'M' }, // Million 
                    { key: 1000000000, value: 'B' }, // Billion            
                     { key: 10000000000, value: 'K Cr' }, // Billion            
                    // { key: 1000000000000, value: 'L Cr' }, // Billion            
                    // { key: 100000000000000, value: 'Cr Cr' }, // Billion                        
                ];
                limitNumbersTo = 3;
            }
        }

        // Loop through each $divisor and find the
        // lowest amount that matches

        var divisor = null;
        var divisorLength = divisors.length - 1;
        if(metricUnit !== 'in'){
            divisor=divisors[0];
            // divisors.map(function(innerData, index) {
            //     var div = (Math.abs(number) / (innerData.key));
            //     if(!((div.toString().indexOf('e-7') !== -1) && metricUnit == 'in')) {
            //         if ((div == 1 || index == divisorLength) && !divisor) {//if division is one or innerdata reaches to maximum then set the divisor                
            //             divisor = innerData;
            //         }
            //         // Ensure when number is too low i.e contains 'e-' then don't go inside this otherwise it will print in 'e-' format
            //         //check the divisor content is less than or equal 2 or greater than 0 then set
            //         if (((!(div.toString().indexOf('e-') !== -1)) && div.toString().split('.')[0]).length >= limitNumbersTo && parseInt(div.toString().split('.')[0]) > 0) {
            //             divisor = innerData;
            //         }
            //         //set previous divisor if number is small than current innerdata
            //         if (Math.abs(number) < (innerData.key) && !divisor) {                
            //                 divisor = divisors[index - 1];
            //         }
            //     }
            // })
        }else if(metricUnit == 'in'){
            divisor={key:1,value:''};
        }

        // We found our match, or there were no matches.
        // Either way, use the last defined value for $divisor.
        // if (divisor.value)
        //     return delimitNumbersIndianFormat((number / divisor.key), precision) + ' ' + divisor.value;
            
        return delimitNumbersIndianFormat(oldnumber, precision) + ' ' +divisor.value;
    } else {
        return oldnumber;
    }
}

export function delimitNumbersIndianFormat(x, position) {
    position = position ? parseInt(position):0;
    let base = 4 + position - 2;
    if (Math.floor(x) >= 0) {
        var newX = Math.floor(x);
        var decimal = parseFloat(x - newX).toFixed(position);
        if(decimal==1){
            newX=newX+1;   
        } 
        decimal=decimal.substring(1, base);
        newX = newX.toString();
    } else {
        var newX = Math.ceil(x);
        newX = newX < 0 ? newX : -newX;
        var decimal = parseFloat(x - newX).toFixed(position);
        if(decimal==-1){
            newX=newX-1;   
        } 
        decimal=decimal.substring(2, base);
        decimal = decimal[0] == '.' ? decimal : (((x - newX)).toString()).substring(1, base);
        newX = newX == 0 ? "-" + newX.toString() : newX.toString();
    }
    if(decimal==0)
        decimal='';
	decimal = decimal==='.' || decimal==="" ? parseFloat(0).toFixed(position).substring(1) : decimal;
    var lastThree = newX.substring(newX.length - 3);
    var otherNumbers = newX.substring(0, newX.length - 3);
    if (otherNumbers != '' && otherNumbers != '-' && otherNumbers != '+')
        lastThree = ',' + lastThree;
    return (otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree).toString() + decimal;
}

export function refineData(value, metric, metricFunction) {
    var newLabel = [];
    if (metric != undefined && value != undefined) {
        metric.forEach(function(data, key) {
            newLabel = modifyWithFunction(data, metricFunction, value, newLabel);
        });
        if (newLabel.length)
            return newLabel[0];
        else {
            if (value == 'difference' || value == 'Absolute Change') {
                var newLabel = [];
                newLabel['type'] = 'order';
                newLabel['label'] = 'Absolute Change';
                newLabel['value'] = value;
                newLabel['metricUnit'] = '';
                return newLabel;
            } else if (value == 'growthRate' || value == 'Growth Rate') {
                var newLabel = [];
                newLabel['type'] = 'order';
                newLabel['label'] = 'Growth Rate';
                newLabel['value'] = value;
                newLabel['metricUnit'] = '';
                return newLabel;
            } else if (value == 'evolution') {
                var newLabel = [];
                newLabel['type'] = 'order';
                newLabel['label'] = 'Growth Rate ( % )';
                newLabel['value'] = value;
                newLabel['metricUnit'] = '';
                return newLabel;
            }
        }
    }
    return null;
}

export function calculateData(data) {
    mainArray = [];
    data.map(function(innerData, index) {
        if (index == 0) {
            Object.keys(innerData).map(function(ininData) {
                if (ininData == 'label')
                    mainArray[ininData] = 'Total';
                else if (typeof innerData[ininData] != 'string') {
                    mainArray[ininData] = 0;
                    mainArray[ininData] += innerData[ininData];
                } else {
                    mainArray[ininData] = '-';
                }
            })
        } else {
            Object.keys(innerData).map(function(ininData) {
                if (typeof innerData[ininData] != 'string') {
                    mainArray[ininData] += innerData[ininData];
                }
            })
        }
    })
    return [mainArray];
}

export function legendDataTotable(mainData, metricGiven, clusterCount, dataFor) {
    colorLabel = JSON.parse(JSON.stringify(colors));
    colorLabel.splice(clusterCount);
    finalArray = [];
    metricGiven = metricGiven.split(',');
    colorLabel.map(function(data, index) {
        for (i = 0; i < metricGiven.length; i++) {
            if (metricGiven[i] == dataFor || dataFor == 'all') {
                metricVal = refineData(metricGiven[i]).label;
                finalArray.push({ label: 'Cluster' + (index + 1), metric: metricVal, color: '<label style="background-color:' + data + '" class="spanColor"></label>', countData: String(mainData[data].pincodes.length), mean: mainData[data].mean['metric' + i], min: mainData[data].min['metric' + i], max: mainData[data].max['metric' + i], action: '<a onclick="MainComponent.downLoadData(\'' + data + '\')" class="tableIcon" title="Download"><i class="fa fa-download"></i></a>&nbsp;&nbsp;<a data-toggle="modal" data-target="#modal-example" class="tableIcon" title="Save segment"><i class="icon-save"></i></a>' });
            }
        }
    });
    return finalArray;
}

export function legendDataMapTotable(mainData, metricGiven, clusterCount, dataFor) {
    if (mainData) {
        colorLabel = JSON.parse(JSON.stringify(colors));
        colorLabel.splice(clusterCount);
        colorLabel.push('all');
        finalArray = [];
        metricGiven = metricGiven.split(',');
        colorLabel.map(function(data, index) {
            for (i = 0; i < metricGiven.length; i++) {
                if (metricGiven[i] == dataFor || dataFor == 'all') {
                    metricVal = refineData(metricGiven[i], metric, metricFunction).label;
                    meanData = mainData[data].mean[metricGiven[i]] / mainData[data].pincodes.length;
                    finalArray.push({ label: 'Cluster' + (index + 1), metric: metricVal, color: '<label style="background-color:' + data + '" class="spanColor"></label>', countData: String(mainData[data].pincodes.length), mean: meanData, min: mainData[data].min[metricGiven[i]], max: mainData[data].max[metricGiven[i]], action: '<a onclick="downloadSegment(\'' + data + '\')" class="tableIcon" title="Download"><i class="fa fa-download"></i></a>&nbsp;&nbsp;<a data-toggle="modal" data-target="#modal-example" class="tableIcon" title="Save segment"><i class="icon-save"></i></a>' });
                }
            }
        });
        var totalData = finalArray.splice(clusterCount);
        totalData[0].label = 'all';
        totalData[0].color = '-';
        totalData[0].action = '-';
        return { data: finalArray, total: totalData };
    } else return { data: null, total: null }
}

export function legendfunction(data, metricGiven, clusterCount) {
    colorLabel = JSON.parse(JSON.stringify(colors));
    colorLabel.splice(clusterCount);
    colorArray = [];
    metricGiven = metricGiven.split(',');
    colorLabel.map(function(data) {
        colorArray[data] = { mean: [], min: [], max: [] };
        metricGiven.map(function(innerData, index) {
            colorArray[data].mean['metric' + index] = 0;
            colorArray[data].min['metric' + index] = 0;
            colorArray[data].max['metric' + index] = 0;
            colorArray[data].pincodes = [];
        });
    });
    colorNumber = metricGiven.length + 1;
    pincodeNumber = metricGiven.length;
    data.map(function(outerData, index0) {
        if (index0 != 0) {
            colorArray[outerData[colorNumber]].pincodes.push(outerData[pincodeNumber]);
            metricGiven.map(function(innerData, index1) {
                colorArray[outerData[colorNumber]].mean['metric' + index1] += outerData[index1];
                if (colorArray[outerData[colorNumber]].min['metric' + index1] == 0)
                    colorArray[outerData[colorNumber]].min['metric' + index1] = outerData[index1];
                else
                    colorArray[outerData[colorNumber]].min['metric' + index1] = outerData[index1] < colorArray[outerData[colorNumber]].min['metric' + index1] ? outerData[index1] : colorArray[outerData[colorNumber]].min['metric' + index1];
                colorArray[outerData[colorNumber]].max['metric' + index1] = outerData[index1] > colorArray[outerData[colorNumber]].max['metric' + index1] ? outerData[index1] : colorArray[outerData[colorNumber]].max['metric' + index1];
            });
        }
    });
    return colorArray;
}

export function legendMapfunction(data, metricGiven, clusterCount) {
    if (data == 0) {
        return false;
    }
    colorLabel = JSON.parse(JSON.stringify(colors));
    colorLabel.splice(clusterCount);
    colorArray = [];
    metricGiven = metricGiven.split(',');
    colorLabel.map(function(data) {
        colorArray[data] = { mean: [], min: [], max: [] };
        colorArray['all'] = { mean: [], min: [], max: [] };
        metricGiven.map(function(innerData, index) {
            colorArray[data].mean[innerData] = 0;
            colorArray[data].min[innerData] = 0;
            colorArray[data].max[innerData] = 0;
            colorArray[data].pincodes = [];
            colorArray['all'].mean[innerData] = 0;
            colorArray['all'].min[innerData] = 0;
            colorArray['all'].max[innerData] = 0;
            colorArray['all'].pincodes = [];
        });
    });
    colorNumber = metricGiven.length + 1;
    pincodeNumber = metricGiven.length;
    data.map(function(outerData, index0) {
        colorArray[outerData['color']].pincodes.push(outerData['Label']);
        colorArray['all'].pincodes.push(outerData['Label']);
        metricGiven.map(function(innerData, index1) {
            colorArray[outerData['color']].mean[innerData] += outerData[innerData];
            colorArray['all'].mean[innerData] += outerData[innerData];
            if (colorArray[outerData['color']].min[innerData] == 0) {
                colorArray[outerData['color']].min[innerData] = outerData[innerData];
                colorArray['all'].min[innerData] = outerData[innerData];
            } else {
                colorArray[outerData['color']].min[innerData] = outerData[innerData] < colorArray[outerData['color']].min[innerData] ? outerData[innerData] : colorArray[outerData['color']].min[innerData];
                colorArray['all'].min[innerData] = outerData[innerData] < colorArray['all'].min[innerData] ? outerData[innerData] : colorArray['all'].min[innerData];
            }
            colorArray[outerData['color']].max[innerData] = outerData[innerData] > colorArray[outerData['color']].max[innerData] ? outerData[innerData] : colorArray[outerData['color']].max[innerData];
            colorArray['all'].max[innerData] = outerData[innerData] > colorArray['all'].max[innerData] ? outerData[innerData] : colorArray['all'].max[innerData];
        });
    });
    return colorArray;
}

//segment export function for handling react export function calls
export function reactFunctionHandle(type, value, parameter, text, flag) {
    // SegmentComponent.downloadUserData(\"" + value['id'] + "\#$" + value['name'] + "\#$" + value['enableUserSegment'] + "\")
    if (type == 1) {
        jQuery("#btn-saveEnable").attr("onclick", "handleEnableDownload(" + value + "," + parameter + ")");
        document.getElementById("alertDataEnable").innerHTML = text;
    } else if (type == 2) {
        showUserData(value + "#$" + parameter + "#$" + text)
    } else if (type == 3) {
        jQuery("#btn-saveArchive").attr("onclick", "handleArchiveSegment(" + value + "," + parameter + ")");
        document.getElementById("alertData").innerHTML = text;
    } else if (type == 4) {
        downloadUserData(value + "#$" + parameter + "#$" + text + "#$" + flag)
    }
}

//segment Create table data
export function modifyCreatedSegmentData(data) {
    if (data == null)
        return 0;
    finalData = [];
    data.map(function(value, index) {
        var archiveSegment = 0;
        var downloadSegment = 0;
        var action;
        var download;
        var downloadText = '';
        var isEnableUserSegment = parseInt(value['enableUserSegment']);
        var url = value['url'];
        if (url) {
            var editSegment = url.substring(0, url.indexOf("?"));
            editSegment += '?' + value['segmentParam'] + '&segmentId=' + value['id'] + '&segmentName=' + value['name'] + '&editSegment' + true;
        } else {
            editSegment = '';
        }
        var flag1 = true;
        var flag2 = false;
        if (!isEnableUserSegment) {
            downloadSegment = 1;
            download = "<i style='padding-left:15px;cursor:pointer' class='fa fa-lock' id='enableDownload" + value['id'] + "'  data-toggle='modal' data-id='" + value['id'] + "' href='#enableUserSegmentPopup' title='Enable download user segment' onclick='reactFunctionHandle(1," + value['id'] + "," + downloadSegment + ",\"Are sure You want Enable user segment download\")' role='button'></i>";
            showSegment = '';
        } else {
            downloadSegment = 0;
            download = "<i style='padding-left:15px;cursor:pointer' class='fa fa-unlock'  data-toggle='modal' href='#enableUserSegmentPopup' title='Disable download user segment' onclick='reactFunctionHandle(1," + value['id'] + "," + downloadSegment + ",\"Are sure You want Disable user segment download\")' role='button'></i>";
            // SegmentComponent.showUserData(\"" + value['id'] + "\#$" + value['name'] + "\#$" + value['enableUserSegment'] + "\")
            // showSegment = "<i style='padding-left:15px;cursor:pointer' disabled class='fa fa-eye' data-name='" + value['name'] + "' data-id='" + value['id'] + "' role='button' title='Show user segment' onclick='reactFunctionHandle(2," + value['id'] + ",\"" + value['name'] + "\"," + value['enableUserSegment'] + ")'></i>";
            showSegment = "<div>/<div>";
        }

        if (value['status'] == '1') {
            archiveSegment = 0;
            action = "<i style='padding-left:15px;' class='fa fa-check' data-toggle='modal' href='#archiveSegmentPopup' title='Enable segment' onclick='reactFunctionHandle(3," + value['id'] + "," + archiveSegment + ",\"Are sure You want Enable this Segment\")' role='button'></i>";
        } else {
            archiveSegment = 1;
            action = "<i style='padding-left:15px;cursor:pointer' id='archiveSegment" + value['id'] + "' class='fa fa-times' data-toggle='modal' data-id='" + value['id'] + "' href='#archiveSegmentPopup' title='Archive segment' onclick='reactFunctionHandle(3," + value['id'] + "," + archiveSegment + ",\"Are sure You want Disable this Segment\")' role='button'></i>" + download + "<i style='padding-left:15px;cursor:pointer' disabled class='fa fa-download' data-name='" + value['name'] + "' data-id='" + value['id'] + "' role='button' title='Download user segment' onclick='reactFunctionHandle(4," + value['id'] + ",\"" + value['name'] + "\"," + value['enableUserSegment'] + "," + flag2 + ")'></i>" + "<i style='padding-left:15px;cursor:pointer' disabled class='fa fa-user' data-name='" + value['name'] + "' data-id='" + value['id'] + "' role='button' title='Download segment property' onclick='reactFunctionHandle(4," + value['id'] + ",\"" + value['name'] + "\"," + value['enableUserSegment'] + "," + flag1 + ")'></i>" + showSegment + "</a>";
        }
        finalData.push({
            label: value['name'],
            link: url,
            action: action
        });
    });
    return finalData;
}

export function dateComparator(date1, date2) {
    var date1Number = monthToComparableNumber(date1);
    var date2Number = monthToComparableNumber(date2);
    if (date1Number === null && date2Number === null) {
        return 0;
    }
    if (date1Number === null) {
        return -1;
    }
    if (date2Number === null) {
        return 1;
    }

    return date1Number - date2Number;
}

// eg 29/08/2004 my=2000-04-04 23:59 gets converted to 200004042359
export function monthToComparableNumber(date) {
    date = date.replace("<span style='color:#aba9a9'>", "");
    date = date.replace("</span>", "");
    if (date === undefined || date === null) {
        return null;
    }
    var yearNumber = date.substring(0, 4); //6,10
    var monthNumber = date.substring(5, 7);
    var dayNumber = date.substring(8, 10);
    var hourNumber = date.substring(11, 13);
    var minNumber = date.substring(14, 16);
    var secNumber = date.substring(17, 19);
    var result = yearNumber + monthNumber + dayNumber + hourNumber + minNumber + secNumber;
    return result;
}

//close Accordian of chart
export function closeAccordian() {
    jQuery('.contMenu').remove()
}

export function toggleMain() {
    jQuery('.main').toggle();
    jQuery(".child").hide();
}

//drill export function for chart
export function drillFunction(name, event, value, date,filterData) {
    if (event == 'drillAcross' || event == 'drillAcrossTime') {
        valueDemo = [];
        drillGlobalObj['drillAcross'].map(function(data) {
            if (value == data.value) {
                valueDemo.obj = data;
                valueDemo.value = data.value;
            }
        })
    } else if (event == 'segment') {
        valueDemo = null;
    } else if (event == 'deepInsight') {
        valueDemo = null;
    } else if (event == 'chart') {
        valueDemo = value;
    } else if (event == 'extract') {
        valueDemo = value;
    } else valueDemo = drillGlobalObj[event];
    drillHandleFunction(name, valueDemo, event, date,filterData);
}

//chart segment redirect
export function segmentFunction(url) {

    var win = window.open(url, '_blank');
    win.focus();
}

//insightHandle
export function eventHandleInsight(date, Name) {
    insightHandleFunction(date, Name);
    closeSidebar('FilterDiv');
    openSidebar('SidebarInsightDiv', "390px");
}


//drill handling functioon
export function breakUpget(reactObj, demoVar, clickName) {
    var propertyDerived, obj = null;
    if (reactObj.property) {
        if (reactObj.property.indexOf(';') != -1) {
            var propertyToAppend = reactObj.property.split(',');
            propertyToAppend.map(function(data) {
                var temp = data.split(';');
                if (temp[0] == demoVar) {
                    propertyDerived = temp[1];
                }
            })
        } else if (reactObj.property.indexOf(',') != -1) {
            propertyDerived = reactObj.property.split(',')[0];
        }else propertyDerived = reactObj.property;
    } else {
        propertyDerived = reactObj.property;
    }
    // if (propertyDerived == 'pincode' && demoVar) {
    //     var indexVar = demoVar.indexOf('(') - 1;
    //     demoVar = demoVar.substring(0, indexVar);
    //     obj = { 'label': demoVar + " (" + propertyDerived + ")", 'value': demoVar + ";" + propertyDerived };
    // } else 
    obj = { 'label': demoVar + " (" + propertyDerived + ")", 'value': demoVar + ";" + propertyDerived };
    // Modified by Anurag to handle bug in segment creation, drill down, across and back.    
    var tempObj = Object.create(reactObj);
    if (checkParamValueInUrl('breakup')) {
        if (reactObj.SelectedBreakUp) {
            var pushStatus = true;
            reactObj.SelectedBreakUpDisp.map(function(data) {
                if (data.label == obj.label)
                    pushStatus = false;
            })
            if (pushStatus) {
                tempObj.SelectedBreakUpDisp.push(obj);
                tempObj.SelectedBreakUp += ',' + (demoVar == 'Blanks' ? 'Blanks' : demoVar) + ";" + propertyDerived;
            }
        }
    } else {
        tempObj.SelectedBreakUpDisp = [obj];
        tempObj.SelectedBreakUp = (demoVar == 'Blanks' ? 'Blanks' : demoVar) + ";" + propertyDerived;
    }
    return { "SelectedBreakUp": tempObj.SelectedBreakUp, "SelectedBreakUpDisp": tempObj.SelectedBreakUpDisp };
}

export function breakUpgetInsight(reactObj, demoVar, clickName) {
    var propertyDerived, obj = null;
    if (reactObj.property) {
        if (reactObj.property.indexOf(';') != -1) {
            var propertyToAppend = reactObj.property.split(',');
            propertyToAppend.map(function(data) {
                var temp = data.split(';');
                if (temp[0] == demoVar) {
                    propertyDerived = temp[1];
                }
            })
        } else propertyDerived = reactObj.property;
    } else {
        propertyDerived = reactObj.property;
    }
    if (propertyDerived == 'pincode' && demoVar) {
        var indexVar = demoVar.indexOf('(') - 1;
        demoVar = demoVar.substring(0, indexVar);
        obj = { 'label': demoVar + " (" + propertyDerived + ")", 'value': demoVar + ";" + propertyDerived };
    } else obj = { 'label': demoVar + " (" + propertyDerived + ")", 'value': demoVar + ";" + propertyDerived };
    return obj;
}

//google maps function

export function fromLatLngToPoint(latLng, map) {
    var topRight = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
    var bottomLeft = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
    var scale = Math.pow(2, map.getZoom());
    var worldPoint = map.getProjection().fromLatLngToPoint(latLng);
    return new google.maps.Point((worldPoint.x - bottomLeft.x) * scale, (worldPoint.y - topRight.y) * scale);
}

//modifing scatter charts individual color data
export function chartInnerData(data, metricGiven) {
    var mainData = [];
    metricGiven = metricGiven.split(",");
    mainData = data.data.map(function(innerData, index) {
        var tempData = [];
        tempData['Label'] = innerData.name;
        tempData[metricGiven[0]] = innerData.x?innerData.x:innerData.value0;
        tempData[metricGiven[1]] = innerData.y?innerData.y:innerData.value1;
        tempData['color'] = data.color ? data.color : colors[0];
        return tempData
    })
    return mainData;
}

//modifing scatter charts entire data
export function chartToData(data, metricGiven) {
    var mainData = [];
    data.map(function(innerData, index) {
        //pass individual array of colors data to inner data function
        if(innerData.data){
            mainData = mainData.concat(chartInnerData(innerData, metricGiven));
        }
        // else mainData = mainData.concat(chartInnerData(innerData.data, metricGiven));
    })
    return mainData;
}

//cluster Data create export function for chart and hyperlocal
export function clusterInfo(data, metricGiven, clusterCount, type, analysis) {
    if (type == 'chart') {
        data = chartToData(data, metricGiven);
    }
    if (data == 0) {
        return false;
    }
    clusterData = data;
    colorLabel = JSON.parse(JSON.stringify(colors)); //color array copy
    clusterCount=clusterCount==="0"||clusterCount===0?1:clusterCount;
    if(typeof JSON.parse(clusterCount)==="object"){
        // clusterCount=4;
        clusterCount=JSON.parse(clusterCount).quad?2:4;
        colorLabel.splice(clusterCount); //get colors from color array as cluster count
        // var temp_data=JSON.parse(clusterCount);
        if(clusterCount==2)
            colorLabel=["#DCDCDC",'#FE0909'];
        // colorLabel[(temp_data['quad']-1)]='#FE0909';
    }
    else {
        colorLabel.splice(clusterCount); //get colors from color array as cluster count
    }
    colorArray = [];
    metricGiven = metricGiven.split(',');
    //creating dummy color array to put data
    colorLabel.map(function(data) {
        colorArray[data] = { mean: [], min: [], max: [] };
        colorArray['all'] = { mean: [], min: [], max: [] };
        metricGiven.map(function(innerData, index) {
            colorArray[data].mean[innerData] = 0;
            colorArray[data].min[innerData] = 0;
            colorArray[data].max[innerData] = 0;
            colorArray[data].pincodes = [];
            colorArray['all'].mean[innerData] = 0;
            colorArray['all'].min[innerData] = 0;
            colorArray['all'].max[innerData] = 0;
            colorArray['all'].pincodes = [];
        });
    });
    colorNumber = metricGiven.length + 1;
    pincodeNumber = metricGiven.length;
    //insert data to color array
    data.map(function(outerData, index0) {
        colorArray[outerData['color']].pincodes.push(outerData['Label']);
        colorArray['all'].pincodes.push(outerData['Label']);
        metricGiven.map(function(innerData, index1) {
            colorArray[outerData['color']].mean[innerData] += outerData[innerData];
            colorArray['all'].mean[innerData] += outerData[innerData];
            if (colorArray[outerData['color']].min[innerData] == 0) {
                colorArray[outerData['color']].min[innerData] = outerData[innerData];
                colorArray['all'].min[innerData] = outerData[innerData];
            } else {
                colorArray[outerData['color']].min[innerData] = outerData[innerData] < colorArray[outerData['color']].min[innerData] ? outerData[innerData] : colorArray[outerData['color']].min[innerData];
                colorArray['all'].min[innerData] = outerData[innerData] < colorArray['all'].min[innerData] ? outerData[innerData] : colorArray['all'].min[innerData];
            }
            colorArray[outerData['color']].max[innerData] = outerData[innerData] > colorArray[outerData['color']].max[innerData] ? outerData[innerData] : colorArray[outerData['color']].max[innerData];
            colorArray['all'].max[innerData] = outerData[innerData] > colorArray['all'].max[innerData] ? outerData[innerData] : colorArray['all'].max[innerData];
        });
    });
    writeData(colorArray, metricGiven, type, analysis, colorLabel);
    // return colorArray;
}

//output data to cluster div in filter
export function writeData(data, metricGiven, type, analysis, colorLabel) {
    var htmlData = "<p><strong>Cluster Legends&nbsp;&nbsp;<i class='fa fa-download' onclick=downloadData('','','" + metricGiven.toString() + "') style='cursor:pointer' title='Save Segment' data-toggle='tooltip' data-placement='bottom'></i></strong></p>";
    var j = 0;
    Object.keys(data).map(function(innerData, index) {
        if (innerData != 'all') {
            data;
            metricGiven;
            // var mean = "", min = "", max = "", number = "";
            var textToPrint = "",number = "",high_low="";
            for (var i = 0; i < metricGiven.length; i++) {
                var refinedMetric = refineData(metricGiven[i], metricGlobal, metricFunction).label;
                textToPrint += "<label style=text-decoration:underline>" + refinedMetric + " :<br>";
                if((analysis==="quadrant" || analysis==="radius,quadrant") && colorLabel.length>2){
                    index = colorLabel.indexOf(innerData);
                    var low_or_high=(index==0 || index==1) && i==1?"Low":(index==2 || index==3) && i==1?"High":(index==0 || index==2) && i==0?"Low":(index==1 || index==3) && i==0?"High":"Low";
                    if(i>0)
                        high_low +=" <br> ";
                    high_low += refinedMetric+" : <span class="+(low_or_high==="High"?"text-success":"text-error")+">"+low_or_high+"</span>";
                }
                // textToPrint += "<label>Mean :&nbsp;" + delimitNumbersIndianFormat(data[innerData].mean[metricGiven[i]]) + "</label><br>";
                textToPrint += "<label>Minimum :&nbsp;" + delimitNumbersIndianFormat(data[innerData].min[metricGiven[i]]) + "</label><br>";
                textToPrint += "<label>Maximum :&nbsp;" + delimitNumbersIndianFormat(data[innerData].max[metricGiven[i]]) + "</label><br>";
                // mean += "<label>Mean of " + refinedMetric + ":&nbsp;" + delimitNumbersIndianFormat(data[innerData].mean[metricGiven[i]]) + "</label>";
                // min += "<label>Minimum value of" + refinedMetric + ":&nbsp;" + delimitNumbersIndianFormat(data[innerData].min[metricGiven[i]]) + "</label>";
                // max += "<label>Maximum value of " + refinedMetric + ":&nbsp;" + delimitNumbersIndianFormat(data[innerData].max[metricGiven[i]]) + "</label>";
            }
            j++;
            if (type == 'map') {
                var property = getParameterByName('city');
                if (property == 'all')
                    property = 'city';
                else property = 'pincode';
            } else var property = getParameterByName('property');
            // if (property == 'pincode') {
            //     var tempData = '';
            //     data[innerData].pincodes.map(function(innerData, index) {
            //         if (index != 0)
            //             tempData += ",";
            //         tempData += (innerData.split(' ')[0]) + (';' + property);
            //     })
            // } else var tempData = encodeURI(data[innerData].pincodes.join(';' + property + ',')) + (';' + property);
            number += "<label>Total number of data points:&nbsp;" + delimitNumbersIndianFormat(data[innerData].pincodes.length, 0) + "</label>";
            high_low = "<div style=\"font-weight: bold\">"+high_low.trim()+"</div>";
            htmlData += "<div class='col-md-3' color="+innerData+"><div class='col-md-1 color-point' style='padding: 0px'><i class='fa fa-circle colorDisp' style='color: " + innerData + "' ></i></div><div class='col-md-8 has-popover color-point' data-content='" + number + high_low + textToPrint + "' data-placement='top' data-title='Cluster " + j + "' data-html='true' style='padding: 0px'><p style='padding:6px' href='#' title='' >Cluster " + j + "</p></div><div class='col-md-1' style='padding: 6px 10px 0px 6px'><i class='fa fa-download' onclick=downloadData('" + innerData + "'," + j + ",'" + metricGiven.toString() + "') style='cursor:pointer' title='Save Segment' data-toggle='tooltip' data-placement='bottom'></i></div></div>";
        }
    })
    jQuery("#clusterToDIsp").html(htmlData);
}

export function downloadData(colorClicked, index, metric) {
    var metricArray = [];
    metric = metric.split(',');
    var label = ["Cluster", "Label"];
    Object.values(metric).map(function(innerData, index) {
        var tempData = refineData(innerData, metricGlobal, metricFunction);
        metricArray.push(tempData);
        label.push(tempData.label);
    })
    var content = "";
    content += label.join(",") + "\n";
    clusterData.forEach(function(row, index) {
        if (colorClicked) {
            if (row.color != colorClicked) {
                return;
            }
        }
        var dataDump = [row.color, row.Label, row[metricArray[0].value], row[metricArray[1].value]]
        content += "'" + Object.values(dataDump).join("','") + "\n";
    });
    var hiddenElement = document.createElement('a');
    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(content);
    // hiddenElement.target = '_blank';
    if (colorClicked)
        hiddenElement.download = "Cluster Data " + index + ".csv";
    else hiddenElement.download = 'Cluster Data.csv';
    hiddenElement.click();
}

export function segmentData(data) {
    data = decodeURI(data);
    jQuery("#segmentData").val(data);
    jQuery("#createSegmentPopup").modal('toggle');
}

export function segmentInsert(e) {
    e.preventDefault();
    var data = jQuery('#segmentData').val();
    var category = jQuery('#category').val();
    var title = jQuery('#segmentName').val();
    var allData = "includeProperty=" + data + "&excludeProperty=&breakup=&startDate=" + startDate + "&endDate=" + endDate;
    var previousUrl = document.referrer;
    var currentUrl = window.location.href;
    var hostUrl = window.location.origin;
    currentUrl = currentUrl.replace(hostUrl, '');
    var fd = new FormData();
    var fd = [];
    // fd.append('name', title);
    // fd.append('comment', '');
    // fd.append('category', category);
    // fd.append('previousUrl', previousUrl);
    // fd.append('url', currentUrl);
    // fd.append('segment', allData);

    fd['name'] =  title
    fd['comment'] =  ''
    fd['category'] =  category
    fd['previousUrl'] =  previousUrl
    fd['url'] =  currentUrl
    fd['segment'] =  allData
    
    fd = encodePostBody(fd)
    jQuery("#createSegmentPopup").modal('toggle');
    jQuery.ajax({
        type: 'POST',
        data: fd,
        url: '/dashboard/segment/createsegment',
        contentType: false,
        processData: false,
        success: function(response) {
            response = decodeResponseBody(response)
            checkIfSessionTimedOut(response)
            alert("Successfully created.");
            location.reload();
        }
    });
}

export function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function getOldFrequency(id, frequency) {
    jQuery('#reportId').val(id);
    document.getElementById('frequencyDD').value = frequency;
    var message = '';
    switch (frequency) {
        case '-1':
            message = '';
            break;
        case '1':
            message = 'This report will be scheduled at 06:00 Hours (IST) every day';
            break;
        case '2':
            message = 'This report will be scheduled on Monday at 06:00 Hours (IST) every week';
            break;
        case '3':
            message = 'This report will be scheduled on 1st of Every Month at 06:00 Hours (IST) every week';
            break;
    }
    jQuery('#frequencyTime').text(message);
    jQuery('#oldFrequency').val(frequency);
    jQuery('#updateFrequencyModal').modal('toggle');
}

export function checkParamValueInUrl(valueToCheck, returnValue) {
    var url = window.location.search.split('&');
    var isValuePresent = false;
    var valueToReturn = '';
    url.map(function(value) {
        var param = value.split('=');
        if (param[0] == valueToCheck) {
            if (param[1]) {
                isValuePresent = true;
                valueToReturn = param[1];
                return;
            }
        }
    });
    return returnValue ? valueToReturn : isValuePresent;
}

export function getParameters(param) {
    var url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < url.length; i++) {
        var urlparam = url[i].split('=');
        if (urlparam[0] == param) {
            return urlparam[1];
        }
    }
}

export function getParametersFromString(param, strLocation) {
    if(strLocation) {
        var url = strLocation.slice(strLocation.indexOf('?') + 1).split('&');
        for (var i = 0; i < url.length; i++) {
            var urlparam = url[i].split('=');
            if (urlparam[0] == param) {
                return urlparam[1];
            }
        }
    }
}

export function modifyMetricGlobal(metricGlobal, feature, isPeriod) {;
    var metricGlobalLength = metricGlobal.length;
    var newArray = [];
    for(var i=0; i<metricGlobalLength; i++) {
        var innerData = metricGlobal[i];
        var case1 = feature == 'summary' || feature == 'chart';    // Hide Growth and Share for chart and summary
        var case2 = innerData['showShare'] == 'true';
        var case3 = innerData['showGrowth'] == 'true';
        var case4 = (feature == 'report' && isPeriod);  // Hide growth metric for timeseries
        if((case1 && case2) || (case4 && case3))    
            continue;
        newArray.push(innerData);
    }
    return newArray;
}

//metric disp function
export function metricDataToDisp(metricMain, metricFunction, selectedMetric) {
    var disp = [];
    selectedMetric = selectedMetric.split(',');
    metricGlobal.map(function(innerData) {
        //pass single metric and get the data with modified function
        modifyWithFunction(innerData, metricFunction, selectedMetric, disp);
    })
    var finalMetrics = [];
    var length = disp.length;
    selectedMetric.map(function(data){
        for(var key=0;key<length;key++) {
            if(disp[key].value == data) {
                finalMetrics.push(disp[key]);
                break;
            }
        }
    });
    return finalMetrics;
}

//export function used convert metric array with function
export function modifyWithFunction(innerData, metricFunction, selectedMetric, disp) {
    if (metricFunction) {
        metricFunction.map(function(data) {
            if (typeof selectedMetric !== "object") {
                if (data.value == "" && selectedMetric.split(';')[1] !== "") {
                    var flag = false;
                } else var flag = true;
            } else var flag = true;
            if (flag) {
                // If selectedMetric is an Array then find the index of metric in selected metric else if its normal string then match it using ==
                var isMetricMatched = selectedMetric instanceof Array ? selectedMetric.indexOf(innerData.value + ";" + data.value) > -1 : selectedMetric == (innerData.value + ";" + data.value);
                if (isMetricMatched) {
                    var tempData = jQuery.extend(true, {}, innerData);
                    tempData.label = data.name + " " + innerData.label;
                    tempData.value += ";" + data.value;
                    disp.push(tempData);
                }
            }
        })
    }
    return disp;
}


// metric right click handling
export function metricContext(metricFunction, handleChange) {
    if (metricFunction) {
        metricFunction.map(function(innerData) {
            $metricFunction[innerData.value] = innerData
        })
    }
    if ($metricFunction.avg) {
        jQuery(function() {
            jQuery.contextMenu({
                selector: '.contextAllow',
                callback: function(key, options) {
                    replaceWordWithFunction(this.context.innerText, key, selectedMetricDisp, $handleChange);
                    // var m = "clicked: " + key;
                    // window.console && console.log(m) || alert(m);
                },
                items: $metricFunction
            });
            if($metricFunction.percentile){
                jQuery.contextMenu({
                    selector: '.noContext',
                    callback: function(key, options) {
                        replaceWordWithFunction(this.context.innerText, key, selectedMetricDisp, $handleChange);
                        // var m = "clicked: " + key;
                        // window.console && console.log(m) || alert(m);
                    },
                    items: {"":{"name":"Default","value":""},"percentile":{"name":"Percentile","value":"percentile"}}
                });
            }
        });
    }
}


//replace existing export function with new function
export function replaceWordWithFunction(text, functionName, selectedMetricDisp, $handleChange) {
    var finalFunction = null;
    metricFunction.map(function(innerData) {
        if (innerData.value === functionName) {
            finalFunction = innerData;
        }
    })
    selectedMetricDisp.map(function(innerData) {
        if (innerData.label === text) {
            changeDispObject(innerData, metricFunction, finalFunction);
        }
    })
    $handleChange('metric', selectedMetricDisp);
}

//function to replace existing with new formulae
export function changeDispObject(rightClickMetric, functionsArray, metricToReplace) {
    $done=false;
    functionsArray.map(function(innerData) {
        if (innerData.value && !$done) {
            if (rightClickMetric.value.search('\\b' + innerData.value + '\\b') > -1) {
                rightClickMetric.label = rightClickMetric.label.replace(innerData.name, metricToReplace.name);
                rightClickMetric.value = rightClickMetric.value.replace(new RegExp("\\b" + innerData.value + "\\b"), metricToReplace.value);
                $done=true;
            }
        }else if(metricToReplace.name=="Percentile" && !$done){
            if (rightClickMetric.value[rightClickMetric.value.length-1]==';') {
                rightClickMetric.label = metricToReplace.name+" "+rightClickMetric.label;
                rightClickMetric.value = rightClickMetric.value+""+metricToReplace.value;
                $done=true;
            }
        }
    })
    return rightClickMetric;
}

//export function to add default formulae
export function addDefaultFunction(selectedMetric, functionsArray, defaultFunction) {
    var tempSelectedMetric = jQuery.extend(true, {}, selectedMetric);
    functionsArray.map(function(innerData) {
        if (defaultFunction.toLowerCase() == innerData.value) {
            if (innerData.name && innerData.name != '') {
                tempSelectedMetric.label = innerData.name + " " + tempSelectedMetric.label;
            } else {
                tempSelectedMetric.label = tempSelectedMetric.label;
            }
            tempSelectedMetric.value = tempSelectedMetric.value + ";" + innerData.value;
        }
    })
    return tempSelectedMetric;
}

//export function to create all possible metric combinations
export function createCombination(ogMetrics, metricFunction) {
    var tempSelectedMetricDisp = [];
    if (metricFunction.length && ogMetrics) {
        ogMetrics.map(function(innerData) {
            if (innerData.isDerived == '2') {
                tempSelectedMetricDisp.push(addDefaultFunction(innerData, metricFunction, innerData.defaultFormula));
                tempSelectedMetricDisp.push(addDefaultFunction(innerData, metricFunction, "percentile"));
            } else {
                metricFunction.map(function(functionData) {
                    tempSelectedMetricDisp.push(addDefaultFunction(innerData, metricFunction, functionData.value));
                })
            }
        })
    } else {
        tempSelectedMetricDisp = ogMetrics;
    }
    return tempSelectedMetricDisp;
}

// export function addMinMaxDataToMetricDisp(selectedMetricDisp, minMaxData, metricRange) {
//     var temp = [];
//     if (metricRange) {
//         metricRange = metricRange.split(',');
//         var newRange = [];
//         metricRange.map(function(range) {
//             range = range.split(':');
//             var temp = [];
//             temp.push(range[1]);
//             temp.push(range[2]);
//             newRange[range[0]] = temp;
//         });
//     }
//     if (selectedMetricDisp) {
//         selectedMetricDisp.map(function(innerData) {
//             var tempData = innerData;
//             tempData['min'] = (minMaxData[innerData.value + ":min"]);
//             tempData['max'] = (minMaxData[innerData.value + ":max"]);
//             var from = newRange && newRange[innerData.value] ? newRange[innerData.value][0] : minMaxData[innerData.value + ":min"];
//             tempData['from'] = (from);
//             var to = newRange && newRange[innerData.value] ? newRange[innerData.value][1] : minMaxData[innerData.value + ":max"];
//             tempData['to'] = (to);
//             temp.push(tempData);
//         })
//     }
//     return temp;
// }

var ConstantGrowthPeriod = [
    { label: 'Previous period', value: '0' },
    { label: 'Same period in previous week', value: '1' },
    { label: 'Same period in previous month', value: '2' },
    { label: 'Same period in previous year', value: '3' }
];

export function getPeriodForGrowth(periodComparison) {
    var period = '';
    ConstantGrowthPeriod.map(function(value) {
        if (value.value == periodComparison) {
            period = lowercaseFirstLetter(value.label);
        }
    });
    return period;
}

export function updatePeriodComparisonDropdown(statePeriodComparison, e, type) {
    var periodComparison = statePeriodComparison;
    var localGrowthPeriod = getGrowthPeriod(e, type); 
    var growthPeriod = localGrowthPeriod[0];
    var calculatedGrowthPeriod =  localGrowthPeriod[1];     // calculated period comparison by date range
    if(calculatedGrowthPeriod == '0')      //if calculated periodComparison is '0' means nothing is applicable then set it to calculated period comparison
        periodComparison = calculatedGrowthPeriod;
    else {
        var localPeriod = false;
        growthPeriod.map(function(val, index){  // check if periodComparison set by user in dropdown is in applicable growthPeriod then set user selected periodComparison
            if(val.value == periodComparison && (val.value != '0' || periodComparison == '0')) {
                periodComparison = val.value;
                localPeriod = true;
                return ;
            }
        });
        if(!localPeriod)
            periodComparison = periodComparisonDefault;    // if calculated periodComparison is not same as one selected by user and also previous period comparison is not selected then set default periodComparison set by user in DB
    }
    return {'periodComparison':periodComparison, 'growthPeriod':growthPeriod};
}

export function getGrowthPeriod(startDate, endDate) {
    var growthPeriod = [];
    var returnPeriod = '0';

    growthPeriod[0] = ConstantGrowthPeriod[0];
    if (moment(startDate).format('YYYY-MM-DD') >= moment(startDate).startOf('week').format('YYYY-MM-DD') && moment(endDate).format('YYYY-MM-DD') <= moment(startDate).endOf('week').format('YYYY-MM-DD')) {
        growthPeriod.push(ConstantGrowthPeriod[1]);
        growthPeriod.push(ConstantGrowthPeriod[2]);
        growthPeriod.push(ConstantGrowthPeriod[3]);
        returnPeriod = '1';
    }
    else if (moment(startDate).format('YYYY-MM-DD') >= moment(startDate).startOf('month').format('YYYY-MM-DD') && moment(endDate).format('YYYY-MM-DD') <= moment(startDate).endOf('month').format('YYYY-MM-DD')) {
        growthPeriod.push(ConstantGrowthPeriod[2]);
        growthPeriod.push(ConstantGrowthPeriod[3]);
        returnPeriod = '2';
    }
    else {   // for year case
        var case1 = (moment(startDate).format('YYYY-MM-DD') >= moment(startDate).startOf('year').format('YYYY-MM-DD') && moment(endDate).format('YYYY-MM-DD') <= moment(startDate).endOf('year').format('YYYY-MM-DD'));
        
        if(fiscalMonth) {
            if(granularity == 'month') {
                startDate = moment(startDate, 'YYYY-MM');
                endDate = moment(endDate, 'YYYY-MM');
                var dateDiff = endDate.diff(startDate, 'month');
                var case2 = dateDiff <= 11;
            } else {
                startDate = moment(startDate, 'YYYY-MM-DD');
                endDate = moment(endDate, 'YYYY-MM-DD');
                var dateDiff = endDate.diff(startDate, 'days');
                var case2 = dateDiff <= 365;
            }
        }
        
        if(case1 || case2) {
            growthPeriod.push(ConstantGrowthPeriod[3]);
            returnPeriod = '3';   
        }
    }
    return [growthPeriod, returnPeriod];
}

export function lowercaseFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}

export function getLabel(Metric, metricValue, propertyDisp, breakupDisp, insightType, insightMetric) {
    var metricText = '';
    var propertyText = '';
    var breakupText = '';
    var temp = Array.isArray(metricValue) ?
        metricValue :
        metricValue.split(',');
    var metricCount = temp.length;
    var i = 0;
    Metric.forEach(function(data, index) {
        temp
            .forEach(function(metricValue, metricIndex) {
                if (data.value == metricValue) {
                    if (i != 0) {
                        if (i == metricCount - 1)
                            metricText += ' and ' + data.label;
                        else
                            metricText += ', ' + data.label;
                    } else
                        metricText += data.label;
                    i++;
                }
            });
    });
    if (insightType && insightMetric != 'Absolute Total') {
        metricText = insightMetric === "" || insightMetric === "null" || insightMetric === undefined ?
            BaseInsightMetric :
            insightMetric;
    }
    if (propertyDisp) {
        var propertyCount = propertyDisp.length;
        if (typeof propertyDisp == 'object')
            propertyText = propertyDisp.label;
        if (Array.isArray(propertyDisp) && !propertyText) {
            propertyDisp
                .forEach(function(data, index) {
                    if (index != 0) {
                        if (index == propertyCount - 1)
                            propertyText += ' and ' + data.label;
                        else
                            propertyText += ', ' + data.label;
                    } else {
                        propertyText = data.label;
                    }
                });
        }
    }
    if (breakupDisp) {
        var breakupCount = breakupDisp.length;
        breakupDisp.forEach(function(data, index) {
            if (index != 0) {
                if (index == breakupCount - 1)
                    breakupText += ' and ' + data.label;
                else
                    breakupText += ', ' + data.label;
            } else {
                breakupText = data.label;
            }
        });
    }
    return { 'metricText': metricText, 'propertyText': propertyText, 'breakupText': breakupText };
}

export function rgb2hex(rgb) {
    rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
    return (rgb && rgb.length === 4) ? "#" + ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) + ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) + ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2) :
        '';
}

export function setPeriod(dateDiff) {
    var dateDiff = Math.abs(dateDiff);
    if (granularity == "date" || granularity == "hour") {
        if (dateDiff <= 30)
            return 'Day';
        else if (dateDiff > 30 && dateDiff < 90)
            return 'Week';
        else if (dateDiff >= 90 && dateDiff <= 366)
            return 'Month';
        else if (dateDiff > 366)
            return 'Year';
    } else if (granularity == "month") {
        if (dateDiff > 366)
            return 'Year';
        else
            return 'Month';
    } else if (granularity == "year") {
        return 'Year';
    }
}

export function createFeedbackOption(type) {
    jQuery('#feedbackUl').empty();
    var options = allFeedbackOption[type];
    var options1 = typeof options  == 'string' ? jQuery.parseJSON(options) : (options ? options : null);
    if(options1) {
        var that = this;
        options1.map(function (val, index) {
                var id = val["id"];
                var option = val["option"];
                var li = '<li class="important item ui-sortable-handle" style="line-height: 20px;cursor:auto;background:rgba(247, 247, 247, 0.26);margin-top:5px;border-top: 1px solid #dddddd;border-bottom:1px solid #dddddd;border-right:1px solid #dddddd"><div class="radio" style="padding-left: 5%"><input type="radio" name="feedback" id="' + id + '" onclick="openCommentBox(' + "'" + option + "'" + ')" /><span>' + option + '</span></div></li>';
                jQuery('#feedbackUl').append(li);
            }.bind(that));
    } else {
        var feedbackOptions = null;
    }
}

export function openCommentBox(val) {
    val = val.toLowerCase();
    if(val == 'other' || val == 'others' || val == 'something else')
        jQuery('#feedbackComment').show();
    else jQuery('#feedbackComment').hide();  
}

export function openComment(type, e) {
    var id = jQuery(e.target).attr('id');
    var tempId = id.split('_');
    var feature = tempId[0];
    var feedbackId = tempId[1];
    jQuery('#hiddenFeatureForFeedback').val(feature);
    jQuery('#hiddenFeedbackId').val(feedbackId);
    if(!tempId[1])
        return ;
    createFeedbackOption(feature);
    var likeId;
    var dislikeId;
    if(type == 'like') {
        likeId = '#' + id;
        dislikeId = likeId.replace('Like', 'Dislike');
    } else {
        dislikeId = '#' + id;
        likeId = dislikeId.replace('Dislike', 'Like');
    }
    var likeColor = rgb2hex(jQuery(likeId).css('color'));
    var dislikeColor = rgb2hex(jQuery(dislikeId).css('color'));
    dislikeColor = (dislikeColor == '#222222' || dislikeColor == '#000000')
    ? '#222222'
    : '#ff0000';
    likeColor = (likeColor == '#222222' || likeColor == '#000000')
    ? '#222222'
    : '#ff0000';
    // #ff0000 : red, #222222 or #000000 : black
    if (type.toLowerCase() === 'like') {
        jQuery('#hiddenResponse').val(1);
        if (likeColor == '#222222' && dislikeColor == '#222222')
            jQuery(likeId).css('color', 'red');
        else if (likeColor == '#ff0000' && dislikeColor == '#222222')
            jQuery(likeId).css('color', 'black');
        else if (likeColor == '#222222' && dislikeColor == '#ff0000') {
            jQuery(likeId).css('color', 'red');
            jQuery(dislikeId).css('color', 'black');
    }
    saveComment();
    } else {
        jQuery('#hiddenResponse').val(0);
        if (likeColor == '#222222' && dislikeColor == '#222222')
            jQuery(dislikeId).css('color', 'red');
        else if (likeColor == '#222222' && dislikeColor == '#ff0000')
            jQuery(dislikeId).css('color', 'black');
        else if (likeColor == '#ff0000' && dislikeColor == '#222222') {
            jQuery(dislikeId).css('color', 'red');
            jQuery(likeId).css('color', 'black');
        }
        jQuery('#commentModal').modal('show');
    }
}
    
export function saveComment() {
    var commentId = jQuery('#feedbackUl').find('input:checked').attr('id');
    var comment = document.getElementById('feedbackComment').value;
    var question = document.getElementById('message_body').value;
    var response = document.getElementById('hiddenResponse').value;
    var type = document.getElementById('hiddenFeatureForFeedback').value;
    var feedbackId = document.getElementById('hiddenFeedbackId').value;
    var url = document.location.href;
    jQuery.ajax({
        url: '/dashboard/alfred/feedback',
        data: 'commentId=' + commentId + '&comment=' + comment + '&feedbackId=' + feedbackId +'&question=' + question + '&response=' + response + '&type=' + type + '&url=' + encodeURIComponent(url),
        type: 'get',
        success: function (response) {
            response = decodeResponseBody(response)
            checkIfSessionTimedOut(response)
            checkIfMaintenanceModeOn(response)
            jQuery("#main-content").prepend('<div class="alert alert-info" role="alert" style="width: 30%;position: absolute;z-index: 1002;right: 15px;top: 60px;"><button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>Thank you for your feedback.</div>');
            closeAlert();
            document.getElementById('feedbackComment').value = '';  // clear comment box
            jQuery('#hiddenResponse').empty();  // reset hidden response
            if(type == 'Alfred')
                jQuery('#'+type+'_'+feedbackId+'_Like,#'+type+'_'+feedbackId+'_Dislike').css('color', 'black');   // reset color of both thumbs to black
            jQuery('#commentModal').modal('hide');  // hide comment model
            jQuery('input[name="feedback"]').prop('checked',false);     // reset all radio buttons
            document.getElementById('feedbackComment').style.visibility = 'none'; // hide comment box
        }
    });
}

export function saveUserComment() {
    var commentId = document.getElementById('hiddenCommentId').value;
    var comment = document.getElementById('UserComment').value;
    jQuery.ajax({
        url: '/dashboard/alfred/useraction',
        data: 'id=' + commentId + '&type=comment' + '&response=' + comment,
        type: 'get',
        success: function (response) {
            response = decodeResponseBody(response)
            checkIfSessionTimedOut(response)
            document.getElementById('hiddenCommentId').value = '';  // clear comment box
            jQuery('#' + commentId + '_Comment').empty(); 
        }
    });
    jQuery("#main-content").prepend('<div class="alert alert-info" role="alert" style="width: 30%;position: absolute;z-index: 1002;right: 15px;top: 60px;"><button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>Your comment saved successfully!</div>');
    jQuery('#userCommentModal').modal('hide');
}

export function handleComment(e) {
    var id = jQuery(e.target).attr('id');
    id = id.split('_')[0];
    document.getElementById('hiddenCommentId').value = id;
    jQuery('#userCommentModal').modal('show');
}

export function handleStar(e) {
    var id = jQuery(e.target).attr('id');
    var starId = id.split('_')[0];
    id = "#" + id;
    var color = rgb2hex(jQuery(id).css('color'));
    var starValue = 0;
    if(color == '#222222' || color == '#000000') {
        jQuery(id).css('color', 'red');
        document.getElementById('hiddenStarValue').value = '1';
        starValue = 1;
    } else {
        jQuery(id).css('color', 'black');
        document.getElementById('hiddenStarValue').value = '0';
        starValue = 0;
    }

    jQuery.ajax({
        url: '/dashboard/alfred/useraction',
        data: 'id=' + starId + '&type=star' + '&response=' + starValue,
        type: 'get',
        success: function (response) {
            response = decodeResponseBody(response)
            checkIfSessionTimedOut(response)
        }
    });
}

/*On window close abort all active ajax calls*/
export function onBeforeUnloadAction(){
    if(jQuery.xhrPool.length){
        if (confirm("All your ongoing requests will be cancelled!")) {
            jQuery.xhrPool.abortAll();
        }
        jQuery.xhrPool.abortAll();
    }
}

export function initMap(finalData_maps,chartDivId,drillObj,metaData,latlng_data,color_array) {
    color_array_to_print=color_array;
    markers_array=[];
    var custom_features =[
        {
          "featureType": "administrative",
          "elementType": "geometry",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "administrative.neighborhood",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "poi",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "labels.text",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road.local",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "transit",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "labels.text",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        }
    ];
    if(metaData.analysis=='radius'){
        var new_center=new google.maps.LatLng(Number(latlng_data.latitude), Number(latlng_data.longitude));
        var new_zoom=10;
    }else {
        var new_center=new google.maps.LatLng(0, 0);
        var new_zoom=0;
    }
    map = new google.maps.Map(document.getElementById(chartDivId), {
        center: new_center,
        zoom: new_zoom,
        styles: custom_features,
        mapTypeId: google.maps.MapTypeId.ROADMAP
    });
    var latlngbounds = new google.maps.LatLngBounds();
    var infoWindow = new google.maps.InfoWindow();
    finalData_maps.map(function(location, i) {
        // var icon = get_color_marker(location.color);
        // var icon = "https://maps.google.com/mapfiles/ms/icons/" + icon + ".png";
        var icon = {
            // path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0',
            path: google.maps.SymbolPath.CIRCLE,
            scale: 5,
            fillColor: location.color,
            fillOpacity: 1,
            strokeColor: 'white',
            strokeWeight: 1
        };
        var myLatlng=new google.maps.LatLng (location.lat,location.lon);
        var marker = new google.maps.Marker({
            position: myLatlng,
            animation: google.maps.Animation.DROP,
            // icon: new google.maps.MarkerImage(icon),
            icon: icon,
            map: map,
            color: location.color
        });
        (function (marker, location) {
            google.maps.event.addListener(marker, "click", function (e) {
                if(drillObj.drillDown && drillObj.drillDown.obj)
                    var clickevent="<button onclick=drillFunction('"+location.name+"',\'drillDown\',\'\',null)>Drill Down</button>";
                else if((metaData.category.toLowerCase()=="zip_code" || metaData.category.toLowerCase()=="pincode" || metaData.category.toLowerCase()=="branch_sol_id") && metaData.analysis!='radius' &&  metaData.analysis!='radius,quadrant'){
                    var input="<input type='number' style='padding: 0px;width: 100px;line-height: 28px;height: 28px;' class='form-control input-lg text-right' id='radius_number' />";
                    // var clickevent="<button data-toggle='modal' data-target='#radius-input-modal'>Vicinity</button>";
                    var clickevent=input+"<button style='width:70px' class='btn btn-contrast input-group-addon' onclick=\"drillFunction('"+location.name+"','drillDown','',null)\">Vicinity</button>";
                    clickevent="<div class='input-group' style='padding-top:10px'>"+clickevent+"</div>"
                    // jQuery("#radius-input").html(input);
                }
                else var clickevent="";
                // clickevent += "&nbsp;<button onclick=\"event.preventDefault();eventHandleInsight('','" + location.name + "')\"><i class='fa fa-lightbulb-o'></i>Auto Analysis</button>";
                var display=metaData.property.label+" : "+location.name;
                var metric_actual_value=metaData.selectedMetric.split(',');
                var metric_value0=metric_actual_value[0]===metaData.selectedMetricDisp[0].value?metaData.selectedMetricDisp[0]:metaData.selectedMetricDisp[1];
                if(metric_actual_value[1])
                    var metric_value1=metric_actual_value[1]===metaData.selectedMetricDisp[1].value?metaData.selectedMetricDisp[1]:metaData.selectedMetricDisp[0];
                if((location.value0 || location.value) && metric_value0)
                    display+="<br>"+metric_value0.label+" : "+number_shorten(location.value0?location.value0:location.value,metric_value0.roundOff,metric_value0.metricUnit);
                if(location.value1 && metric_value1)
                    display+="<br>"+metric_value1.label+" : "+number_shorten(location.value1,metric_value1.roundOff,metric_value1.metricUnit);
                if(location.distance)
                    display+="<br>Distance : "+delimitNumbersIndianFormat(location.distance*1.60934,2)+" KM";
                infoWindow.setContent("<div style = 'width:200px;min-height:40px'>" + display + "<br/>"+clickevent+"</div>");
                infoWindow.open(map, marker);
            });
        })(marker, location);
        markers_array.push(marker);
        latlngbounds.extend(marker.position);
    });
    //Get the boundaries of the Map.
    var bounds = new google.maps.LatLngBounds();
    //Center map and adjust Zoom based on the position of all markers.
    map.setCenter(latlngbounds.getCenter());
    map.fitBounds(latlngbounds);
    if(metaData.analysis==="radius" || metaData.analysis==="radius,quadrant"){
        var cluster_value=JSON.parse(metaData.clusterCount).radius;
        var cityCircle = new google.maps.Circle({
            strokeColor: '#FF0000',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            // fillColor: '#FF0000',
            fillOpacity: 0.35,
            map: map,
            center: {lat: Number(latlng_data.latitude), lng: Number(latlng_data.longitude)},
            radius: Number(cluster_value)*1000
        });
        var cityCircle = new google.maps.Circle({
            strokeColor: 'green',
            strokeOpacity: 0.8,
            strokeWeight: 10,
            // fillColor: '#FF0000',
            fillOpacity: 1,
            map: map,
            center: {lat: Number(latlng_data.latitude), lng: Number(latlng_data.longitude)},
            radius: 1*400
        });
    }
    // google.maps.event.trigger(map, 'resize');
    // if(JSON.parse(metaData.clusterCount).quad){
    //     setTimeout(function(){
    //         var quad_to_disp = JSON.parse(metaData.clusterCount).quad;
    //         quad_to_disp=quad_to_disp.split(",");
    //         var n=quad_to_disp.length;
    //         jQuery('#clusterToDIsp').children().css('color','lightgrey');
    //         jQuery('.colorDisp').css('color','lightgrey');
    //         jQuery('#clusterToDIsp>p').css('color','black');
    //         var temp_color_array_to_print=[];
    //         for(var i=0;i<n;i++){
    //             var color_parent=colors[quad_to_disp[i]-1];
    //             jQuery('#clusterToDIsp').children()[quad_to_disp[i]].style.color=color_parent;
    //             jQuery('.colorDisp')[quad_to_disp[i]-1].style.color=color_parent;
    //             color_array_to_print.splice(color_array_to_print.indexOf(color_parent),1)
    //             temp_color_array_to_print.push(color_parent);
    //         }
    //         color_array_to_print=temp_color_array_to_print;
    //         reloadMarkers(color_array_to_print,metaData,latlng_data,chartDivId);
    //     }, 1000);
    // }
    jQuery(".color-point").click(function(){
        var color_parent=this.parentElement.attributes.color.value;
        if(color_array_to_print.indexOf(color_parent)>-1){
            this.parentElement.style.color="lightgrey";
            this.parentElement.children[0].children[0].style.color="lightgrey";
            color_array_to_print.splice(color_array_to_print.indexOf(color_parent),1);
        }
        else {
            this.parentElement.style.color="";
            this.parentElement.children[0].children[0].style.color=color_parent;
            color_array_to_print.push(color_parent);
        }
        reloadMarkers(color_array_to_print,metaData,latlng_data,chartDivId);
    });
}

export function reloadMarkers(color_array_to_print,metaData,latlng_data,chartDivId){
    markers_array.map(function(location, i) {
        if(color_array_to_print.indexOf(location.color)>-1)
            location.setMap(map);
        else location.setMap(null);
    });
}

export function get_color_marker(hex){
    var icon="red";
    switch (hex) {
        case "#DCDCDC":
            icon = "grey";
            break;
        case "#FE0909":
            icon = "red";
            break;
        case '#2f7ed8':
            icon = "blue";
            break;
        case '#0d233a':
            icon = "orange";
            break;
        case '#8bbc21':
            icon = "green";
            break;
        case '#910000':
            icon = "pink";
            break;
        case '#1aadce':
            icon = "yellow";
            break;
    }
    return icon
}


export function async_check(){
    if(location.pathname!="/dashboard/downloads" && location.pathname!="/dashboard/start" && location.pathname!="/dashboard/start/"){
        jQuery.ajax({
            type: 'Get',
            url: '/dashboard/charttype/checkdownload',
            async: true,
            success: function (data) {
                data = decodeResponseBody(data)
                checkIfSessionTimedOut(data)
                if(data!=0 && data!=false && data!="false"){
                    if(data && notification_count!=data){
                        if(data.length>1)
                            var text_for_download=data.length + " downloads available ";
                        else var text_for_download=data[0].title +" is ready for download ";
                        jQuery("#main-content").prepend('<div class="alert alert-info alert-dismissible" data-notify-position="top-right" style="display: inline-block; margin: 0px auto; position: fixed; transition: all 0.5s ease-in-out; z-index: 1031; top: 81px; right: 20px;"><button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>'+text_for_download+'<a href="/dashboard/downloads" target="_blank">Click here</a>!</div>');
                        notification_count=data;
                    }
                    document.getElementById('highlight-download').style.display='block';
                }
                else document.getElementById('highlight-download').style.display='none';
            }
        });
    }
}

export function dragcomplete(){
    if(highChartsDiv){
        highChartsDiv.map(function(innerData,index){
            highChartsDiv[index].setSize(jQuery(jQuery('#container'+index).parents()[3]).width()-0,jQuery(jQuery('#container'+index).parents()[3]).height()-90,false)
        })
    }
    if(count_reports){
        count_reports.map(function(innerData,index){
            jQuery('#myGridTop'+(innerData+1)).height(jQuery(jQuery('#myGridTop'+(innerData+1)).parents()[3]).height()-90)
        })
    }
}

export function disable_zoom_charts(){
    highChartsDiv.map(function(innerData,index){
        highChartsDiv[index].options.chart.zoomType="none";
        highChartsDiv[index].reflow();
    })
}

export function save(){
    var serializedData = [];
    jQuery('.grid-stack > .grid-stack-item:visible').map(function(i,el) {
        el = jQuery(el);
        var node = el.data('_gridstack_node');
        if(node.id){        
            serializedData.push({
                x: node.x,
                y: node.y,
                id: node.id,
                width: node.width,
                height: node.height
            });
        }
    });
    jQuery.ajax({
        type: 'Get',
        async: false,
        data: "dashboard_id="+id_dashboard+"&dashboard_json=" + JSON.stringify(serializedData),
        url: '/dashboard/dashboard/save',
        success: function (response) {
            response = decodeResponseBody(response)
            checkIfSessionTimedOut(response)
            location.reload();
        }
    });
}

export function handle_cancel_dashboard(index,text){
    document.getElementById('title_charts_'+index).innerHTML=text+"<i class='fa fa-pencil-square-o' onclick='handle_edit_chart_title("+index+",\""+text+"\")' style='margin-left:10px' data-toggle='tooltip' title='Edit Chart Title' data-placement='right'></i>";
}

export function handle_save_dashboard(index){
    var value=document.getElementById('chart_title_'+index).value;
    jQuery.ajax({
        type: 'Get',
        async: false,
        data: "dashboard_id="+id_dashboard+"&pin_id=" + index + "&pin_text="+encodeURIComponent(value),
        url: '/dashboard/dashboard/save_pin_title',
        success: function (response) {
            response = decodeResponseBody(response)
            checkIfSessionTimedOut(response)
            document.getElementById('title_charts_'+index).innerHTML=value+"<i class='fa fa-pencil-square-o' onclick='handle_edit_chart_title("+index+",\""+value+"\")' style='margin-left:10px' data-toggle='tooltip' title='Edit Chart Title' data-placement='right'></i>";
        }
    });
}

export function tableResizeHandled(){
    var column_values=gridOptions.columnApi.getColumnState();
    var n=column_values.length;
    for(var i=0;i<n;i++){
        if(column_values[i].width<150){
            gridOptions.api.setHeaderHeight(80);
            break;
        }else gridOptions.api.setHeaderHeight(40);
    }
    if(document.getElementById('saveGridSetting'))
        document.getElementById('saveGridSetting').style.display="inline-block";
}

export function table_drill_handle(metricData){
    var metric_array=[];
    metricData.split(',').forEach(element => {
        metric_array.push(refineData(element, metricGlobal, metricFunction));
    });
    handleChange_function('metric', metric_array);
}

export function GetSortOrder(prop,sort) {
    if(sort=='asc'){
        return function(a, b) {
            if (a[prop] > b[prop]) {
                return 1;
            } else if (a[prop] < b[prop]) {
                return -1;
            }
            return 0;
        }
    }else {
        return function(a, b) {
            if (a[prop] < b[prop]) {
                return 1;
            } else if (a[prop] > b[prop]) {
                return -1;
            }
            return 0;
        }
    }
}

export function IsJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export function logoutHandle() {    
    localStorage.clear()
    location.href="/workspace";
}

export function checkIfSessionTimedOut(result) {
    if(Array.isArray(result) && result['status_code'] == '408') {
        let information = result['information'] ? result['information'] : "Session Timed Out. Please login again."        
        alert(information)        
        logoutHandle();
    }
}

Array.prototype.getColumn = function(name) {
    return this.map(function(el) {
       // gets corresponding 'column'
       if (el.hasOwnProperty(name)) return el[name];
       // removes undefined values
    }).filter(function(el) { return typeof el != 'undefined'; }); 
}


export  {getParametersFromString as default};